module.exports = __webpack_public_path__ + "img/AT0000002610259.b0f17f7c.png";